module.exports = __webpack_public_path__ + "img/item4-5.0eeae4dd.jpg";